export { default } from "./DatoCmsDoubleImage";
